import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { PulseLoader } from "react-spinners";
import "../../assets/css/style.css";
import Header from "../Header/HeaderOTM";
import otmIcon from "../../assets/angket/otmIcon.png";
import progressIcon from "../../assets/angket/growth.png";
import { APILA } from "../../config/apila";
import { APIMS } from "../../config/apims";

export default function DashboardParent() {
  const navigate = useNavigate();
  document.title = "Assessment Platform - Orang Tua";

  const token = localStorage.getItem("token");

  // ====== DETEKSI MOBILE (HP) ======
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth <= 576;
  });

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 576);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ====== HEADER AXIOS (sesuai screenshot) ======
  const axiosHeaders = useMemo(() => {
    return {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
  }, [token]);

  // ====== State API ======
  const [loading, setLoading] = useState(true);
  const [apiError, setApiError] = useState("");
  const [otmInfo, setOtmInfo] = useState(null);
  const [penilaianAnak, setPenilaianAnak] = useState(null);
  const [activeSemesterId, setActiveSemesterId] = useState("");

  const studentProfile = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("student_profile") || "{}");
    } catch {
      return {};
    }
  }, []);

  const studentA = useMemo(() => {
    return {
      name: studentProfile?.nama_siswa || "-",
      studentId: localStorage.getItem("nisn") || "-",
      ysb_student_id:
        studentProfile?.ysb_student_id ||
        localStorage.getItem("ysb_student_id") ||
        "-",
      ysb_branch_id:
        studentProfile?.ysb_branch_id ||
        localStorage.getItem("ysb_branch_id") ||
        "-",
      ysb_school_id:
        studentProfile?.ysb_school_id ||
        localStorage.getItem("ysb_school_id") ||
        "-",
      ysb_grade_level_id:
        studentProfile?.ysb_grade_level_id ||
        localStorage.getItem("ysb_grade_level_id") ||
        "-",
      ysb_kelas_id:
        studentProfile?.ysb_kelas_id ||
        localStorage.getItem("ysb_kelas_id") ||
        "-",
      ysb_kelas_name:
        studentProfile?.ysb_kelas_name ||
        localStorage.getItem("ysb_kelas_name") ||
        "-",
      ysb_grade_level_name:
        studentProfile?.ysb_grade_level_name ||
        localStorage.getItem("ysb_grade_level_name") ||
        "-",
      ysb_semester_id:
        studentProfile?.ysb_semester_id ||
        localStorage.getItem("ysb_semester_id") ||
        "-",
    };
  }, [studentProfile]);

  const fetchActiveSemester = async () => {
  try {
    const res = await APIMS.get("/api/access/semesters", {
      headers: axiosHeaders,
      params: {
        page: 1,
        limit: 100,
        ascending: 0,
      },
    });

    const semesters = res?.data?.data || [];

    const activeSemester = semesters.find(
      (item) => Number(item?.status) === 1
    );

    if (activeSemester?.id) {
      setActiveSemesterId(activeSemester.id);

      // Simpan juga agar halaman form OTM ikut memakai semester aktif
      localStorage.setItem("ysb_semester_id", activeSemester.id);

      return activeSemester.id;
    }

    return studentA.ysb_semester_id;
  } catch (err) {
    console.error("Gagal load semester aktif:", err);

    // fallback agar fitur lama tetap aman
    return studentA.ysb_semester_id;
  }
};

  // fallback (kalau parent_profile / student_profile masih dipakai)
  const parentProfile = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("parent_profile") || "{}");
    } catch {
      return {};
    }
  }, []);

  const childProfile = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("student_profile") || "{}");
    } catch {
      return {};
    }
  }, []);

  // Fetch dashboard-otm
  // useEffect(() => {
  //   let mounted = true;

  //   const fetchDashboard = async () => {
  //     setLoading(true);
  //     setApiError("");

  //     try {
  //       const branchId = localStorage.getItem("ysb_branch_id") || "";
  //       const schoolId = localStorage.getItem("ysb_school_id") || "";
  //       const semesterId = localStorage.getItem("ysb_semester_id") || "";
  //       const studentId = localStorage.getItem("ysb_student_id") || "";
  //       const gradeLevelId = localStorage.getItem("ysb_grade_level_id") || "";

  //       // validasi biar gak error "field is required"
  //       if (!branchId || !schoolId || !semesterId || !studentId || !gradeLevelId) {
  //         setApiError(
  //           "Data login tidak lengkap (branch/school/semester/student/grade). Silakan login ulang."
  //         );
  //         setLoading(false);
  //         return;
  //       }

         
  //       const res = await APILA.get(
  //         "/api/dashboard-otm",
  //         {
  //           headers: axiosHeaders,
  //           params: {
  //             ysb_branch_id: branchId,
  //             ysb_school_id: schoolId,
  //             ysb_semester_id: semesterId,
  //             ysb_student_id: studentId,
  //             ysb_grade_level_id: gradeLevelId,
  //           },
  //         }
  //       );

  //       const payload = res?.data?.data;
  //       if (!payload) {
  //         throw new Error("Data API tidak valid.");
  //       }

  //       if (!mounted) return;

  //       setOtmInfo(payload.otm_info || null);
  //       setPenilaianAnak(payload.penilaian_anak || null);
  //     } catch (err) {
  //       if (!mounted) return;

  //       const msg =
  //         err?.response?.data?.message ||
  //         err?.message ||
  //         "Gagal memuat data dashboard.";
  //       setApiError(msg);
  //     } finally {
  //       if (mounted) setLoading(false);
  //     }
  //   };

  //   fetchDashboard();

  //   return () => {
  //     mounted = false;
  //   };
  // }, [axiosHeaders]);

  // Fetch dashboard-otm
useEffect(() => {
  let mounted = true;

  const fetchDashboard = async () => {
    setLoading(true);
    setApiError("");

    try {
      const branchId =
        studentA.ysb_branch_id !== "-"
          ? studentA.ysb_branch_id
          : localStorage.getItem("ysb_branch_id") || "";

      const schoolId =
        studentA.ysb_school_id !== "-"
          ? studentA.ysb_school_id
          : localStorage.getItem("ysb_school_id") || "";

      const studentId =
        studentA.ysb_student_id !== "-"
          ? studentA.ysb_student_id
          : localStorage.getItem("ysb_student_id") || "";

      const gradeLevelId =
        studentA.ysb_grade_level_id !== "-"
          ? studentA.ysb_grade_level_id
          : localStorage.getItem("ysb_grade_level_id") || "";

      // Ambil semester aktif dulu, sama seperti dashboard siswa
      const semesterIdAktif = await fetchActiveSemester();

      if (!mounted) return;

      // validasi biar gak error "field is required"
      if (!branchId || !schoolId || !semesterIdAktif || !studentId || !gradeLevelId) {
        setApiError(
          "Data login tidak lengkap (branch/school/semester/student/grade). Silakan login ulang."
        );
        setLoading(false);
        return;
      }

      const res = await APILA.get("/api/dashboard-otm", {
        headers: axiosHeaders,
        params: {
          ysb_branch_id: branchId,
          ysb_school_id: schoolId,
          ysb_semester_id: semesterIdAktif,
          ysb_student_id: studentId,
          ysb_grade_level_id: gradeLevelId,
        },
      });

      const payload = res?.data?.data;
      if (!payload) {
        throw new Error("Data API tidak valid.");
      }

      if (!mounted) return;

      setOtmInfo(payload.otm_info || null);
      setPenilaianAnak(payload.penilaian_anak || null);
    } catch (err) {
      if (!mounted) return;

      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Gagal memuat data dashboard.";

      setApiError(msg);
    } finally {
      if (mounted) setLoading(false);
    }
  };

  fetchDashboard();

  return () => {
    mounted = false;
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [
  axiosHeaders,
  studentA.ysb_branch_id,
  studentA.ysb_school_id,
  studentA.ysb_student_id,
  studentA.ysb_grade_level_id,
  studentA.ysb_semester_id,
]);

  // ====== Data tampilan (utama dari API, fallback dari localStorage) ======
  const parent = useMemo(() => {
    const ayah = otmInfo?.nama_lengkap_ayah;
    const ibu = otmInfo?.nama_lengkap_ibu;

    // kalau API ada, tampilkan Ayah/Ibu. kalau tidak, fallback parent_profile.
    return {
      name:
        (ayah || ibu)
          ? `${ayah ? ayah : "Ayah"}${ayah && ibu ? " & " : ""}${ibu ? ibu : ""}`
          : parentProfile?.nama_orang_tua || "Orang Tua",
      relation: parentProfile?.hubungan || "Wali Murid",
      ayah: ayah || "-",
      ibu: ibu || "-",
    };
  }, [otmInfo, parentProfile]);

  const child = useMemo(() => {
    return {
      name: otmInfo?.nama_siswa || childProfile?.nama_siswa || "Nama Anak",
      studentId: otmInfo?.nisn || localStorage.getItem("nisn") || "-",
      ysb_student_id: otmInfo?.ysb_student_id || childProfile?.ysb_student_id || "-",
      ysb_school_id: otmInfo?.ysb_school_id || childProfile?.ysb_school_id || "-",
      ysb_grade_level_id:
        otmInfo?.ysb_grade_level_id || childProfile?.ysb_grade_level_id || "-",
      ysb_semester_id:
        otmInfo?.ysb_semester_id || childProfile?.ysb_semester_id || "-",
    };
  }, [otmInfo, childProfile]);

  // ====== Cards dari API ======
  const cards = useMemo(() => {
    const total = Number(penilaianAnak?.total_questions || 0);
    const answered = Number(penilaianAnak?.answered || 0);
    const status = penilaianAnak?.status || "Belum";

    return {
      parentAssessment: {
        title: "Penilaian Orang Tua",
        subtitle: "Evaluasi Perilaku Anak",
        status,
      },
      progress: {
        title: "Progres Penilaian",
        subtitle: "Presentase Penyelesaian",
        done: answered,
        total: total,
        percent: Number(penilaianAnak?.progress_percentage || 0),
      },
    };
  }, [penilaianAnak]);

  const progressPercent =
    cards.progress.total > 0 ? (cards.progress.done / cards.progress.total) * 100 : 0;

  const isSelesai =
    String(cards.parentAssessment.status || "").toLowerCase() === "selesai";

  // const goToAssessment = () => {
  //   navigate("/assessment-parent-form");
  // };

  const goToAssessment = () => {
  const semesterIdAktif =
    activeSemesterId ||
    localStorage.getItem("ysb_semester_id") ||
    studentA.ysb_semester_id ||
    "";

  if (semesterIdAktif) {
    localStorage.setItem("ysb_semester_id", semesterIdAktif);
  }

  const qs = new URLSearchParams();

  if (semesterIdAktif) {
    qs.set("ysb_semester_id", semesterIdAktif);
  }

  navigate(`/assessment-parent-form?${qs.toString()}`);
};

  const handleLogout = () => {
    localStorage.removeItem("parent_logged_in");
    localStorage.removeItem("parent_profile");

    localStorage.removeItem("student_profile");
    localStorage.removeItem("token_expiry");
    localStorage.removeItem("ysb_student_id");
    localStorage.removeItem("nama_siswa");
    localStorage.removeItem("ysb_semester_id");
    localStorage.removeItem("ysb_branch_id");
    localStorage.removeItem("ysb_school_id");
    localStorage.removeItem("ysb_grade_level_id");
    localStorage.removeItem("ysb_kelas_id");
    localStorage.removeItem("ysb_teacher_id");
    localStorage.removeItem("ysb_teacher_id2");
    localStorage.removeItem("nisn");
    localStorage.removeItem("token");

    navigate("/");
  };

  return (
    <div style={styles.page}>
      <Header />

      <main style={styles.container}>
        {/* LOADING: jangan tampilkan content dulu */}
        {loading ? (
          <div style={styles.loadingWrap}>
            <PulseLoader />
          </div>
        ) : apiError ? (
          <div style={styles.errorBox}>
            <div style={styles.errorTitle}>Gagal memuat dashboard</div>
            <div style={styles.errorText}>{apiError}</div>
          </div>
        ) : (
          <>
            <section style={{ marginBottom: 18 }}>
              <h1 style={styles.welcomeTitle}>Assalamualaikum, Ayah / Bunda!</h1>

              {/* INFO ANAK: mobile per-baris */}
              <div
                style={{
                  ...styles.studentBadgeWrap,
                  ...(isMobile ? styles.studentBadgeWrapMobile : {}),
                }}
              >
                <span
                  style={{
                    ...styles.studentBadge,
                    ...(isMobile ? styles.studentBadgeMobile : {}),
                  }}
                >
                  Nama Anak: {child.name}
                </span>

                <span
                  style={{
                    ...styles.studentBadge,
                    ...(isMobile ? styles.studentBadgeMobile : {}),
                  }}
                >
                  NISN: {child.studentId}
                </span>

                <span
                  style={{
                    ...styles.studentBadge,
                    ...(isMobile ? styles.studentBadgeMobile : {}),
                  }}
                >
                  Kelas: {studentA.ysb_grade_level_name} - {studentA.ysb_kelas_name}
                </span>

                <span
                  style={{
                    ...styles.studentBadge,
                    ...(isMobile ? styles.studentBadgeMobile : {}),
                  }}
                >
                  Sekolah: {child.ysb_school_id}
                </span>
              </div>
            </section>

            <section style={styles.gridTopCards}>
              {/* Card penilaian parent */}
              <div
                style={{
                  ...styles.card,
                  cursor: isSelesai ? "not-allowed" : "pointer",
                }}
                role="button"
                tabIndex={0}
                onClick={() => {
                  if (!isSelesai) goToAssessment();
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !isSelesai) goToAssessment();
                }}
              >
                <div style={styles.cardHeader}>
                  <div>
                    <img style={{ width: 62 }} src={otmIcon} alt="otm" />
                  </div>

                  <div>
                    <span
                      style={{
                        ...styles.badge,
                        background:
                          cards.parentAssessment.status === "Selesai"
                            ? "#DCFCE7"
                            : cards.parentAssessment.status === "Proses"
                            ? "#FEF3C7"
                            : "#FEE2E2",
                        color:
                          cards.parentAssessment.status === "Selesai"
                            ? "#166534"
                            : cards.parentAssessment.status === "Proses"
                            ? "#92400E"
                            : "#DC2626",
                      }}
                    >
                      {cards.parentAssessment.status}
                    </span>
                  </div>
                </div>

                <h3 style={styles.cardTitle}>{cards.parentAssessment.title}</h3>
                <p style={styles.cardSubtitle}>{cards.parentAssessment.subtitle}</p>
              </div>

              {/* Card progress */}
              <div style={styles.card}>
                <div style={styles.cardHeader}>
                  <div>
                    <img style={{ width: 62 }} src={progressIcon} alt="progress" />
                  </div>
                  <div>
                    <span style={styles.counterText}>
                      {cards.progress.done}/{cards.progress.total}
                    </span>
                  </div>
                </div>

                <h3 style={styles.cardTitle}>{cards.progress.title}</h3>
                <p style={styles.cardSubtitle}>{cards.progress.subtitle}</p>

                <div style={styles.progressTrack}>
                  <div
                    style={{
                      ...styles.progressFill,
                      width: `${progressPercent}%`,
                    }}
                  />
                </div>
              </div>
            </section>

            <section style={styles.card}>
              <h3 style={styles.sectionTitle}>Menilai Anak</h3>

              {/* ROW MENILAI ANAK: mobile button pindah ke bawah nama anak */}
              <div
                style={{
                  ...styles.peerRow,
                  ...(isMobile ? styles.peerRowMobile : {}),
                }}
              >
                <div
                  style={{
                    ...styles.peerLeft,
                    ...(isMobile ? styles.peerLeftMobile : {}),
                  }}
                >
                  <div
                    style={{
                      ...styles.iconPill,
                      background: "#EEF2FF",
                      color: "#6366F1",
                      ...(isMobile ? styles.iconPillMobile : {}),
                    }}
                  >
                    🧒
                  </div>

                  <div style={{ width: "100%" }}>
                    <div style={styles.peerName}>{child.name}</div>
                    <div style={styles.peerGrade}>
                      NISN: {child.studentId} • Kelas: {studentA.ysb_grade_level_name} -{" "}
                      {studentA.ysb_kelas_name}
                    </div>

                    {/* BUTTON DI BAWAH NAMA ANAK KHUSUS MOBILE */}
                    {isMobile && (
                      <Button
                        color="primary"
                        style={{
                          ...styles.startBtn,
                          ...(isMobile ? styles.startBtnMobile : {}),
                          opacity: isSelesai ? 0.7 : 1,
                          cursor: isSelesai ? "not-allowed" : "pointer",
                        }}
                        onClick={goToAssessment}
                        disabled={isSelesai}
                        title={isSelesai ? "Penilaian sudah selesai" : "Mulai Penilaian"}
                      >
                        Mulai Penilaian
                      </Button>
                    )}
                  </div>
                </div>

                {/* BUTTON DESKTOP/TABLET (non-mobile) tetap di kanan */}
                {!isMobile && (
                  <Button
                    color="primary"
                    style={{
                      ...styles.startBtn,
                      opacity: isSelesai ? 0.7 : 1,
                      cursor: isSelesai ? "not-allowed" : "pointer",
                    }}
                    onClick={goToAssessment}
                    disabled={isSelesai}
                    title={isSelesai ? "Penilaian sudah selesai" : "Mulai Penilaian"}
                  >
                    Mulai Penilaian
                  </Button>
                )}
              </div>
            </section>
          </>
        )}
      </main>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "#F8FAFC",
    color: "#111827",
    fontFamily:
      'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  container: { maxWidth: 1220, margin: "0 auto", padding: "22px 18px 28px" },
  welcomeTitle: { margin: 0, fontSize: 28, fontWeight: 800, lineHeight: 1.1 },

  gridTopCards: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: 16,
    marginBottom: 16,
  },

  card: {
    background: "#FFFFFF",
    border: "1px solid #E5E7EB",
    borderRadius: 14,
    padding: 18,
    boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
  },

  loadingWrap: {
    width: "100%",
    minHeight: "55vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  errorBox: {
    border: "1px solid #FCA5A5",
    background: "#FEF2F2",
    color: "#7F1D1D",
    borderRadius: 14,
    padding: 16,
  },
  errorTitle: { fontWeight: 800, marginBottom: 6 },
  errorText: { fontWeight: 600 },

  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 14,
  },

  iconPill: {
    width: 38,
    height: 38,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 16,
    fontWeight: 700,
    flexShrink: 0,
  },

  badge: { fontSize: 12, fontWeight: 700, padding: "5px 10px", borderRadius: 999 },
  cardTitle: { margin: "0 0 6px", fontSize: 22, fontWeight: 800 },
  cardSubtitle: { margin: "0 0 10px", fontSize: 14, color: "#6B7280", fontWeight: 500 },
  counterText: { fontWeight: 700, color: "#374151" },

  progressTrack: {
    width: "100%",
    height: 10,
    background: "#E5E7EB",
    borderRadius: 999,
    overflow: "hidden",
    marginTop: 8,
  },
  progressFill: {
    height: "100%",
    background: "#22C55E",
    borderRadius: 999,
    transition: "width .25s ease",
  },

  sectionTitle: { margin: "0 0 14px", fontSize: 22, fontWeight: 800, color: "#3b60e8" },

  peerRow: {
    background: "#F8FAFC",
    border: "1px solid #E5E7EB",
    borderRadius: 12,
    padding: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
  },

  peerLeft: { display: "flex", alignItems: "center", gap: 10, width: "auto" },
  peerName: { fontSize: 16, fontWeight: 700 },
  peerGrade: { fontSize: 13, color: "#6B7280" },

  startBtn: {
    borderRadius: 10,
    padding: "10px 16px",
    fontWeight: 700,
    whiteSpace: "nowrap",
  },

  studentBadgeWrap: { marginTop: 10, display: "flex", gap: 8, flexWrap: "wrap" },
  studentBadge: {
    background: "#f5fcf7",
    color: "#28A745",
    border: "1px solid #b8d9c0",
    borderRadius: 999,
    fontWeight: 700,
    fontSize: 12,
    padding: "5px 10px",
  },

  // ====== MOBILE OVERRIDES ======
  studentBadgeWrapMobile: {
    flexDirection: "column",
    alignItems: "stretch",
    gap: 8,
  },
  studentBadgeMobile: {
    width: "100%",
    borderRadius: 12,
    padding: "10px 12px",
    fontSize: 13,
  },

  peerRowMobile: {
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "flex-start",
  },
  peerLeftMobile: {
    width: "100%",
    alignItems: "flex-start",
  },
  iconPillMobile: {
    marginTop: 2,
  },
  startBtnMobile: {
    width: "100%",
    marginTop: 12,
    padding: "12px 14px",
  },
};